import { useLayoutEffect } from "react";
import { useLayout } from "../../service-layout";

export const EMBED_READY_MSG = "embed::ready";
export const EMBED_CLOSE_MSG = "embed::close";
export const EMBED_SELECT_MSG = "embed::select";

// API of the useEmbed custom hook:
const useDefaultHook = () => ({
  embedReadyMsg: EMBED_READY_MSG,
  embedSelectMsg: EMBED_SELECT_MSG,
  embedCloseMsg: EMBED_CLOSE_MSG
});

export const useEmbedPage = (isEmbedReady = true, hook = useDefaultHook) => {
  const { isEmbed, embedID, embedScope, embedParams } = useLayout();

  const api = {
    isEmbed,
    isStandalone: !isEmbed,
    embedID,
    embedScope,
    embedParams
  };

  // Get the customizations out of the custom hook pattern:
  const {
    embedReadyMsg = EMBED_READY_MSG,
    embedSelectMsg = EMBED_SELECT_MSG,
    embedCloseMsg = EMBED_CLOSE_MSG
  } = hook(api) || {};

  // Allows to forward generic messages out:
  const embedMessage = (name, data = {}) => {
    window.parent.postMessage(
      JSON.stringify({
        embedID,
        name,
        data
      }),
      "*"
    );
  };

  // Notable message to communicate an item selection:
  const embedSelect = (item) => embedMessage(embedSelectMsg, item);
  const embedClose = () => embedMessage(embedCloseMsg);

  // Automatically sends out the "page::ready" message
  useLayoutEffect(() => {
    if (isEmbedReady) {
      embedMessage(embedReadyMsg);
    }
  }, [isEmbedReady]);

  return {
    ...api,
    embedMessage,
    embedSelect,
    embedClose
  };
};
